import { CustomerStatus, visitDashboard } from '@raisin/cp-utils';
import { getAccount, getAvailableBalance, getTotalBalance } from './account';
import { getActionItems } from './actionItems';
import { getCorporateNavigation } from './corporateMenus';
import { getCustomerMenus, getNonExportedCustomerMenus } from './customerMenus';
import { getMenuLinks } from './links';
import { getLoginNavigation } from './loginMenus';
import { getLogoItems, getSkeletonLogoItems } from './logos';
import { getNavItems } from './menus';
import messages from './messages';
import { getLocaleNavigation } from './publicMenus';
import { getRaisinBankNavigation } from './raisinBankMenus';
import { getRegistrationNavigation } from './registrationMenus';
const getLoginStatusDataSource = ({ isThemeV2, customer, cobranding, transactionAccountData, productAccess, globalSettings, ppDashboardData, unreadMessagesCount, intl, locale, shouldShowPaymentMethodScreens, transactionAccountError, hasDWMProduct, hasMigratedRobo, userManagementPensionLogout, userManagementCallObsLogout, isHeaderDataLoading, pomProducts, productsTypes, t, b2cUseNewDashboard, dbtShowNewMyDepositsPage, }) => {
    const { fullName = '', firstName = '', lastName = '', distributorId = '', isPendingActivation = 'false', status = CustomerStatus.Active, } = customer !== null && customer !== void 0 ? customer : {};
    const isCustomerActive = (customer === null || customer === void 0 ? void 0 : customer.status) === CustomerStatus.Active;
    const menuLinks = getMenuLinks(locale);
    const dataSource = {
        type: 'private',
        logoItems: getLogoItems(isThemeV2, b2cUseNewDashboard, distributorId, globalSettings, cobranding, locale),
        navItems: getNavItems({
            navProps: {
                customer,
                productAccess,
                pensionProductsData: ppDashboardData,
                unreadMessagesCount,
                hasDWMProduct,
                hasMigratedRobo,
                pomProducts,
                b2cUseNewDashboard,
                dbtShowNewMyDepositsPage,
                productsTypes,
            },
            locale,
        }),
        customer: {
            displayName: `${firstName} ${lastName}`,
            fullName,
            accountIds: getAccount(transactionAccountData, t, isCustomerActive, locale),
            totalBalance: getTotalBalance(customer, transactionAccountData, intl, t),
            availableBalance: getAvailableBalance(customer, transactionAccountData, intl, t),
            subMenus: isPendingActivation
                ? getNonExportedCustomerMenus(customer, menuLinks, locale)
                : getCustomerMenus({
                    menuProps: {
                        menuLinks,
                        customer,
                        shouldShowPaymentMethodScreens,
                    },
                    locale,
                }),
            actionItems: getActionItems({
                t,
                userManagementPensionLogout,
                userManagementCallObsLogout,
            }),
            showUnreadMessage: !!unreadMessagesCount,
            state: status,
            balanceIsNotAvailable: (transactionAccountData === null || transactionAccountData === void 0 ? void 0 : transactionAccountData.isMaintenance) || transactionAccountError,
            notAvailableMessage: {
                title: t(messages.maintenanceTitle),
                tooltipText: (transactionAccountData === null || transactionAccountData === void 0 ? void 0 : transactionAccountData.isMaintenance)
                    ? t(messages.maintenanceTooltip)
                    : t(messages.fetchBalanceError),
            },
        },
        isHeaderDataLoading,
    };
    return dataSource;
};
const getLogoutStatusDataSource = (isThemeV2, distributorInfo, logoHref, locale = 'en-US') => {
    const dataSource = getLocaleNavigation(locale, isThemeV2, distributorInfo, logoHref);
    return dataSource;
};
const getRegistrationDataSource = (isThemeV2, regflow, locale = 'en-US') => {
    const dataSource = getRegistrationNavigation(isThemeV2, locale, regflow);
    return dataSource;
};
const getLoginDataSource = (locale = 'en-US', isThemeV2) => {
    const dataSource = getLoginNavigation(locale, isThemeV2);
    return dataSource;
};
const getCorporateDataSource = (isThemeV2) => {
    const dataSource = getCorporateNavigation(isThemeV2);
    return dataSource;
};
const getRaisinBankDataSource = (isThemeV2) => getRaisinBankNavigation(isThemeV2);
const getLoggedInDefaultDataSource = (isThemeV2, b2cUseNewDashboard, isHeaderDataLoading, distributor_id, locale = 'en-US', cobranding) => {
    const dashboardUrl = visitDashboard(b2cUseNewDashboard, true);
    return {
        logoItems: [
            ...getSkeletonLogoItems(isThemeV2, locale),
            ...((cobranding === null || cobranding === void 0 ? void 0 : cobranding.logo)
                ? [
                    {
                        id: 'header-logo-bar-partner-logo',
                        href: dashboardUrl,
                        url: cobranding.logo,
                        alt: distributor_id,
                    },
                ]
                : []),
        ],
        type: 'private',
        isHeaderDataLoading,
        navItems: [],
    };
};
const getIPPDistributionPartnerDataSource = (isThemeV2, logoHref, distributorInfo, locale = 'en-US') => {
    const localeMenu = getLocaleNavigation(locale, isThemeV2, distributorInfo, logoHref);
    return {
        logoItems: localeMenu.logoItems,
        type: 'public',
        isHeaderDataLoading: false,
        navItems: [],
        actionItems: localeMenu.actionItems.filter((menu) => menu.type === 'login'),
    };
};
const countrySelectorMenu = {
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cc89-42d0-8263-f0d9079e2c14',
            href: '/en/country-selector/',
            url: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
            alt: 'Raisin',
        },
    ],
    navItems: null,
    actionItems: [],
};
export { countrySelectorMenu, getLoginDataSource, getLoginStatusDataSource, getLogoutStatusDataSource, getRegistrationDataSource, getLoggedInDefaultDataSource, getCorporateDataSource, getIPPDistributionPartnerDataSource, getRaisinBankDataSource, };
//# sourceMappingURL=index.js.map